export const PDF_VIEWER_CONFIG = {
  // Zoom settings
  ZOOM_MIN: 0.5,
  ZOOM_MAX: 3.0,
  ZOOM_STEP: 0.2,
  DEFAULT_SCALE: 1.0,
  
  // Rotation step
  ROTATION_STEP: 90,
  
  // Performance settings
  ENABLE_ANNOTATIONS: false, // Can be toggled based on performance needs
  ENABLE_TEXT_LAYER: true,
  
  // Default dimensions
  DEFAULT_HEIGHT: 'h-256',
  FULLSCREEN_HEIGHT: 'h-[calc(100vh-60px)]',
} as const;

export type PDFViewerConfigType = typeof PDF_VIEWER_CONFIG;